<template>
  <!-- <div class="register-success-container"> -->
  <div :class="['register-success-container', registerClass]">
    <div
      v-if="userPlatform === 2"
      class="register-close"
      @click="closeCard"
    ></div>
    <div class="register-success-head">
      <img class="gou-img" src="../../assets/images/register/gou.png" alt="" />

      <div class="re-success-title">注册成功</div>
      <div class="re-success-tips">等待人工审核，请注意接听电话!</div>
      <div class="re-success-sub-title" >
        <div class="userInfo" v-if="userInfo && userInfo.userName">
          <div class="info-item">
            <img src="@/assets/images/register/username.png" />
            <span>
              帐号：<span class="content-highlight" >{{ userInfo.userName }}</span>
            </span>
          </div>
          <div class="info-item">
            <img src="@/assets/images/register/password.png" />
            <span>
              密码：<span class="content-highlight">{{ userInfo.userPwd }}</span>
            </span>
          </div>
        </div>
        <div class="tips">
          <span class="red">*</span>注意：账号注册成功后，我们将会有客服联系您为您开通账号权限，请注意接听电话！
        </div>
      </div>
    </div>

    <div class="re-success-card-tip">
      <a href="http://www.baiinfo.com/" target="blanket" > 您可以去网站查看相关资讯 </a>
    </div>
    <div class="re-card-bottom-tip">
      <img
        class="bottom-tip-icon"
        src="../../assets/images/register/telephone.png"
        alt=""
      />

      客服热线：<a href="tel:18618300427" class="color-t333">18618300427</a>
    </div>

    <!-- <div class="re-success-bottom-tip">
      <div class="bottom-tip-head">
        <img
          class="tip-head-icon"
          src="../../assets/images/register/warn.png"
          alt=""
        />
        提示：
      </div>
      <div class="bottom-tip-content">
        您的账号已注册成功，稍后，我们会有客服电话与您联系，请耐心等待并接听电话，感谢您的注册。
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  props:{
    userInfo:{
      type: Object
    }
  },
  computed: {
    ...mapState({
      userPlatform: (state) => state.user.userPlatform,
    }),
    registerClass() {
      if (this.userPlatform === 2) {
        return "registersucc-mask-windows-contaienr";
      }
      return "";
    },
  },

  methods: {
    closeCard() {
      this.$emit("hideCard");
    },
    toBaiWebsite() {
      const website = "http://www.baiinfo.com/";
    },
  },
};
</script>

<style lang="scss" scoped >
.register-success-container {
  position: relative;
  width: 480px;
  flex-basis: 1;
  flex-grow: 1;
  padding: 40px 50px;
  .register-close {
    position: absolute;
    right: 1em;
    top: 1em;
    width: 2em;
    height: 2em;
    padding: 1em;
    background: url("../../assets/images/register/close.png");  
    background-position: 50% 50%;
    background-size: 50%;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .register-success-head {
    position: relative;
    left: 50%;
    top: -120px;
    width: 90vw;
    transform: translateX(-50%);
    padding: 12px 0 30px;
    text-align: center;
    background-color: #ffffff;
    .gou-img {
      height: 40px;
      width: 40px;
      object-fit: cover;
    }
    .re-success-title {
      font-size: 21px;
      height: 30px;
      line-height: 30px;
      font-weight: 500;
      color: #040404;
    }
    .re-success-tips {
      font-size: 18px;
      height: 30px;
      line-height: 30px;
      font-weight: 500;
      color: #040404;
    }
    .re-success-sub-title {
      font-size: 14px;
      font-weight: 400;
      color: #313131;

      .userInfo {
        width: 250px;
        margin: 20px auto 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        row-gap: 4px;
        .info-item {
          display: flex;
          align-items: center;
          column-gap: 10px;
          font-size: 15px;
          img {
            width: 14px;
          }
        }
      }

      .tips {
        position: relative;
        text-align: left;
        width: 300px;
        padding: 12px 10px;
        padding-left: 16px;
        line-height: 20px;
        color: red;
        font-size: 14px;
        background-color: #fafafa;
        border-radius: 0 10px 0 10px;
        margin: 8px auto 0;
        box-shadow: 0 1px 5px 0px rgba(0,0,0,0.2);
        .red {
          position: absolute;
          left: 10px;
          color: red;
        }
      }
    }

    // .content-highlight{
    //   color: #ff0000;
    //   font-weight: bold;
    // }
  }

  .re-success-card-tip {
    width: 280px;
    // height: 44px;
    height: 0;
    overflow: hidden;
    line-height: 42px;
    margin: auto;
    text-align: center;
    border: none;
    color: #2b304d;
    font-size: 14px;
    margin-bottom: 60px;
    a{
    color: #2b304d;

    }
  }

  .re-success-bottom-tip {
    box-sizing: border-box;
    position: absolute;
    top: 130px;
    left: 0;
    height: 70px;
    padding: 10px 30px;
    background: #f6f4ef;
    font-size: 12px;

    font-weight: 500;
    color: #897359;
    line-height: 18px;
    border: 20px solid #ffffff;
    width: 100%;
    border-width: 0 5vw;
    .bottom-tip-head {
      display: flex;
      align-items: center;
      .tip-head-icon {
        width: 13px;
        height: 13px;
        margin-right: 0.5em;
        object-fit: cover;
      }
    }
    .bottom-tip-content {
      // margin-top: 6px;
      font-weight: 400;
      line-height: 16px;
    }
  }
  .re-card-bottom-tip {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #ffffff;
    height: 40px;

    text-align: center;

    font-size: 12px;

    font-weight: 400;
    color: #333333;
    .bottom-tip-icon {
      width: 1.2em;
      height: 1.2em;
      object-fit: cover;
      margin-right: 1em;
    }
  }
}
.registersucc-mask-windows-contaienr {
  .register-success-head {
    position: relative;
    top: 0;
    width: auto;
  }

  .re-success-card-tip {
    height: 44px;
    line-height: 42px;
    border: 1px solid #2b304d;
  }
  .re-success-bottom-tip {
    top: auto;
    bottom: 40px;
    border: none;
  }
}
</style>